/**
 * Audio Constants
 *
 * Configuration for all audio types used in the softphone.
 */

import type {
  AudioConfig,
  AudioType,
} from 'Modules/softphone/services/AudioService/index.types';

export const AUDIO_CONFIGS: Record<AudioType, AudioConfig> = {
  ringtone: {
    // Legacy uses OutgoingCalls.mp3 for incoming calls (incomingTone)
    // This is INTENTIONAL - has been in production for years
    src: require('Assets/audio/OutgoingCalls.mp3') as string,
    volume: 0.49, // 49% volume for incoming calls
    loop: true,
    preload: true,
  },
  ringback: {
    // Legacy uses IncomingCalls.mp3 for outgoing calls (ringTone)
    // This is INTENTIONAL - has been in production for years
    src: require('Assets/audio/IncomingCalls.mp3') as string,
    volume: 1.0, // 100% volume for outgoing ringback (180 Ringing)
    loop: true,
    preload: true,
  },
  callDisconnected: {
    src: require('Assets/audio/CallDisconnected.mp3') as string,
    volume: 1.0, // Default volume
    loop: false,
    preload: true,
  },
  lostConnection: {
    src: require('Assets/audio/LostConnection.mp3') as string,
    volume: 0.5, // Matches legacy PhoneStore.playLostConnectionTone (volume = 0.5)
    loop: true, // Loop until reconnected
    preload: true,
  },
  secondIncoming: {
    src: require('Assets/audio/OnCallIncomingChime.mp3') as string,
    volume: 1.0, // 100% volume for second incoming call alert
    loop: false, // Don't loop - will be replayed every 10 seconds by setInterval
    preload: true,
  },
  remoteAudio: {
    // No src - used for remote call audio
    volume: 1.0,
    loop: false,
    preload: false,
  },
  videoStart: {
    src: require('Assets/audio/VideoStartNotification.mp3') as string,
    volume: 1.0, // 100% volume for video call notifications
    loop: false,
    preload: true,
  },
  videoJoin: {
    src: require('Assets/audio/VideoJoinNotification.mp3') as string,
    volume: 1.0, // 100% volume for participant joined notification
    loop: false,
    preload: true,
  },
  videoLeave: {
    src: require('Assets/audio/VideoLeaveNotification.mp3') as string,
    volume: 1.0, // 100% volume for participant left notification
    loop: false,
    preload: true,
  },
  videoEnded: {
    src: require('Assets/audio/VideoEndedNotification.mp3') as string,
    volume: 1.0, // 100% volume for conference ended notification
    loop: false,
    preload: true,
  },
  // DTMF tones - match legacy volume of 0.2 (20%)
  dtmf0: {
    src: require('Assets/audio/keypad/0.wav') as string,
    volume: 0.2,
    loop: false,
    preload: true,
  },
  dtmf1: {
    src: require('Assets/audio/keypad/1.wav') as string,
    volume: 0.2,
    loop: false,
    preload: true,
  },
  dtmf2: {
    src: require('Assets/audio/keypad/2.wav') as string,
    volume: 0.2,
    loop: false,
    preload: true,
  },
  dtmf3: {
    src: require('Assets/audio/keypad/3.wav') as string,
    volume: 0.2,
    loop: false,
    preload: true,
  },
  dtmf4: {
    src: require('Assets/audio/keypad/4.wav') as string,
    volume: 0.2,
    loop: false,
    preload: true,
  },
  dtmf5: {
    src: require('Assets/audio/keypad/5.wav') as string,
    volume: 0.2,
    loop: false,
    preload: true,
  },
  dtmf6: {
    src: require('Assets/audio/keypad/6.wav') as string,
    volume: 0.2,
    loop: false,
    preload: true,
  },
  dtmf7: {
    src: require('Assets/audio/keypad/7.wav') as string,
    volume: 0.2,
    loop: false,
    preload: true,
  },
  dtmf8: {
    src: require('Assets/audio/keypad/8.wav') as string,
    volume: 0.2,
    loop: false,
    preload: true,
  },
  dtmf9: {
    src: require('Assets/audio/keypad/9.wav') as string,
    volume: 0.2,
    loop: false,
    preload: true,
  },
  dtmfStar: {
    src: require('Assets/audio/keypad/asterisk.wav') as string,
    volume: 0.2,
    loop: false,
    preload: true,
  },
  dtmfPound: {
    src: require('Assets/audio/keypad/pound.wav') as string,
    volume: 0.2,
    loop: false,
    preload: true,
  },
};
